const LIVE_READINESS_FIELDS = [
  'status',
  'responded_at',
  'updated_at',
  'distance_m',
  'eta_minutes',
  'location_freshness',
  'location_is_stale',
  'location_updated_at',
  'check_id',
];

export const incidentReadinessSocketPatch = (event = {}) => {
  const userId = String(event?.user_id || '').trim();
  if (!userId) return null;
  const patch = { user_id: userId };
  LIVE_READINESS_FIELDS.forEach((field) => {
    if (event[field] !== undefined) patch[field] = event[field];
  });
  return patch;
};

const mergeRow = (row, patch) => {
  const next = { ...(row || {}), ...patch };
  return JSON.stringify(row || {}) === JSON.stringify(next) ? row : next;
};

export const mergeIncidentReadinessRows = (rows = [], event = {}) => {
  const patch = incidentReadinessSocketPatch(event);
  if (!patch) return rows;
  let changed = false;
  const next = (rows || []).map((row) => {
    if (String(row?.user_id || '') !== patch.user_id) return row;
    const merged = mergeRow(row, patch);
    if (merged !== row) changed = true;
    return merged;
  });
  return changed ? next : rows;
};

export const mergeIncidentReadinessMap = (readiness = {}, event = {}) => {
  const patch = incidentReadinessSocketPatch(event);
  if (!patch) return readiness;
  const previous = readiness?.[patch.user_id] || { user_id: patch.user_id };
  const merged = mergeRow(previous, patch);
  if (merged === previous && readiness?.[patch.user_id]) return readiness;
  return { ...(readiness || {}), [patch.user_id]: merged };
};

export const mergeStaffingReviewReadiness = (review = {}, event = {}) => {
  const patch = incidentReadinessSocketPatch(event);
  if (!patch) return review;
  let changed = false;
  const cards = (review?.cards || []).map((card) => {
    let cardChanged = false;
    const roles = (card?.roles || []).map((role) => {
      let roleChanged = false;
      const candidates = (role?.candidates || []).map((candidate) => {
        if (String(candidate?.user_id || '') !== patch.user_id) return candidate;
        const merged = mergeRow(candidate, patch);
        if (merged !== candidate) roleChanged = true;
        return merged;
      });
      if (!roleChanged) return role;
      cardChanged = true;
      return { ...role, candidates };
    });
    if (!cardChanged) return card;
    changed = true;
    return { ...card, roles };
  });
  return changed ? { ...review, cards } : review;
};
